import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-387">
    <div className="flex items-center mb-4" data-id="element-388">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-389">
        {initials}
      </div>
      <div data-id="element-390">
        <div className="flex text-brand-gold mb-1 text-[15px] md:text-lg" data-id="element-391">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-392" />)}
        </div>
        <div className="font-medium text-brand-text md:text-lg" data-id="element-393">{name}</div>
        <div className="text-xs md:text-sm text-brand-muted" data-id="element-394">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] md:text-base font-serif leading-relaxed" data-id="element-395">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    text: 'Las preguntas poderosas cambiaron completamente mis sesiones. Ahora logro profundizar mucho más en cada lectura.'
  }, {
    initials: 'JL',
    name: 'Julieta L.',
    location: 'Buenos Aires',
    text: 'Antes dependía demasiado de la intuición. Hoy tengo una estructura clara para acompañar a mis consultantes.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'Mendoza',
    text: 'El módulo de intervención fue lo que más me ayudó. Ahora sé exactamente cómo avanzar cuando la lectura se bloquea.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-396">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px] md:text-sm" data-id="element-397">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-398" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Terapeuta Akáshica — Córdoba',
    text: 'Antes sentía que muchas sesiones dependían únicamente de lo que apareciera en el momento. Hoy tengo una estructura mucho más clara y eso se nota en los resultados.'
  }, {
    initials: 'JL',
    name: 'Julieta L.',
    location: 'Terapeuta Holística — Buenos Aires',
    text: 'El módulo de intervención fue increíble. Me ayudó a sentirme más segura y a acompañar procesos mucho más profundos.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'Terapeuta Energética — Mendoza',
    text: 'Lo que más me sorprendió fue El Altar del Terapeuta. Me ayudó a comunicar mejor mi trabajo y empezaron a llegar consultas más alineadas.'
  }, {
    initials: 'RA',
    name: 'Ricardo A.',
    location: 'Facilitador Akáshico — Santa Fe',
    text: 'Por primera vez sentí que tenía un sistema completo. No solo para mis sesiones, sino también para construir una práctica profesional.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-399">
      <div className="text-center mb-12" data-id="element-400">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-purpleDark pt-[0px]" data-id="element-401">
          ❤️ MÁS TERAPEUTAS QUE YA UTILIZAN HERRAMIENTAS DE LUMEN AKASHA
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] md:text-sm max-w-4xl mx-auto" data-id="element-402">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-403" />)}
      </div>
    </Section>;
};